import React from 'react';
import packageJson from '../../package.json';
const { version } = packageJson;

const AboutScreen: React.FC = () => {
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '800px',
      margin: 'auto',
      fontFamily: 'sans-serif',
      lineHeight: '1.6',
      color: '#333',
    },
    header: {
      textAlign: 'center' as const,
      marginBottom: '30px',
      borderBottom: '1px solid #eee',
      paddingBottom: '20px',
    },
    logo: {
      width: '80px',
      height: '80px',
      marginBottom: '10px',
    },
    appName: {
      fontSize: '2em',
      fontWeight: 'bold',
      margin: '0',
    },
    version: {
      fontSize: '1em',
      color: '#888',
    },
    section: {
      marginBottom: '20px',
    },
    sectionTitle: {
      fontSize: '1.2em',
      fontWeight: 'bold',
      color: '#007bff',
      marginBottom: '10px',
    },
    footer: {
      marginTop: '40px',
      textAlign: 'center' as const,
      fontSize: '0.9em',
      color: '#aaa',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {/* Ganti dengan path logo aplikasi Anda */}
        <img src="/logo192.png" alt="Logo Aplikasi" style={styles.logo} />
        <h1 style={styles.appName}>Aplikasi SDIDTK</h1>
        <p style={styles.version}>Versi {version}</p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Tentang Aplikasi</h2>
        <p>
          Aplikasi ini dirancang untuk membantu orang tua dan tenaga kesehatan dalam melakukan skrining deteksi dini tumbuh kembang (SDIDTK) pada anak. Tujuannya adalah untuk memantau perkembangan anak secara rutin dan mendeteksi secara dini kemungkinan adanya penyimpangan agar dapat segera ditindaklanjuti.
        </p>
      </div>

      <div style={styles.footer}>
        <p>&copy; {new Date().getFullYear()} Tim Pengembang. Hak Cipta Dilindungi.</p>
      </div>
    </div>
  );
};

export default AboutScreen;